import {
  blueGray,
  cyan,
  cyanD1,
  errorD1,
  errorL1,
  lightGray2,
  midGray,
  primaryBlack,
  white,
} from 'shared/theme/colors'
import styled, { css } from 'styled-components'

import { header3, paragraph3 } from '../../theme/typography'
import { CalendarIcon } from '../Icons/Icon'

export const inputActiveLabel = css`
  transform: scale(0.8);
  transform-origin: top left;
  cursor: pointer;
  top: 2px;
  left: 14px;
  font-weight: 500;
`

export const Label = styled.label<{ $active: boolean }>`
  position: absolute;
  top: 17px;
  left: 50px;
  right: 0;
  transition: all 0.2s;
  transform-origin: top left;
  touch-action: manipulation;
  ${header3};
  font-size: 16px !important;
  color: ${lightGray2};
  pointer-events: none;
  text-align: left;

  ${({ $active }) => $active && inputActiveLabel}
`

export const ActiveLabel = styled.span<{ $active: boolean }>`
  opacity: 0;
  ${({ $active }) => $active && `opacity: 1;`}
`

export const DateIcon = styled.img.attrs({
  src: CalendarIcon,
  alt: 'calendar_icon',
})<{ $active: boolean }>`
  transition: all 0.2s;
  width: 18px;
  height: 20px;
  position: absolute;
  left: 16px;
  top: 17px;
  color: ${blueGray};
  ${({ $active }) => $active && `top: 25px !important;`}
`

export const Field = styled.div<{ $hasError: boolean; $noMargin: boolean; $backgroundColor?: string }>`
  position: relative;
  display: flex;
  flex-flow: column-reverse;
  margin-bottom: 24px;
  padding: 16px 1px 0 1px;
  background-color: ${white};
  border-radius: 3px;
  height: 56px;
  width: 100%;
  max-width: 424px;
  min-width: 120px;
  ${({ $backgroundColor }) => $backgroundColor && `background-color: ${$backgroundColor};`}
  ${({ $hasError }) => $hasError && `border: 1px solid ${errorD1}; background-color: ${errorL1};`}
  ${({ $noMargin }) => $noMargin && `margin-bottom: 0;`}

  &:hover {
    cursor: pointer;
  }

  &:focus-within > ${Label} {
    ${inputActiveLabel};
    color: ${cyanD1};
    ${({ $hasError }) => $hasError && `color: ${lightGray2};`};
  }

  &:focus-within ${ActiveLabel} {
    opacity: 1;
  }

  &:focus-within > ${DateIcon} {
    top: 25px !important;
  }
`

export const InputStyled = styled.input<{
  $error?: boolean
  $active?: boolean
}>`
  ${header3};
  font-size: 16px !important;
  line-height: 1.5;
  transition: all 0.2s;
  touch-action: manipulation;
  border: 0;
  border-bottom: 1px solid transparent;
  background: transparent;
  padding: 4px 15px 4px 50px;
  caret-color: ${cyan};
  width: 100%;
  /* stylelint-disable */
  -webkit-appearance: textfield;
  /* stylelint-enable */

  ::-webkit-date-and-time-value {
    text-align: left;
  }

  &::-webkit-date-and-time-value {
    text-align: left;
  }

  &:focus {
    outline: 0;
    border-bottom: 1px solid ${cyanD1};
  }

  &::-webkit-datetime-edit {
    color: transparent;
  }

  &::-webkit-calendar-picker-indicator {
    display: none;
  }

  &:focus::-webkit-datetime-edit {
    color: ${primaryBlack} !important;
  }

  ${({ $error }) => $error && `background-color: ${errorL1} !important;`}
  ${({ $active }) =>
    $active &&
    css`
      &::-webkit-datetime-edit {
        color: ${primaryBlack} !important;
      }
    `}
`

const helperText = css`
  ${paragraph3};
  position: absolute;
  top: 60px;
  left: 0;
`

export const ErrorMessage = styled.div`
  ${helperText};
  color: ${errorD1};

  &::first-letter {
    text-transform: capitalize;
  }
`

export const HelperMessage = styled.div`
  ${helperText};
  color: ${midGray};
`
